/**
 * rocks sprite atlas — GENERATED, do not edit.
 *
 *   Blender --background --python tools/blender/build_items.py -- --atlas
 *   Blender --background --python tools/blender/pack_atlas.py -- ...
 *   node tools/build-item-atlas.mjs
 *
 * Frame coordinates into `/rocks.webp`, rendered from undefined.
 * One sheet is one request: on a slow connection, separate icons cost far more
 * than the icons' worth of bytes.
 */
export const ROCK_URL = '/rocks.webp';
export const ROCK_CELL = 96;
export const ROCK_SIZE = { width: 768, height: 672 } as const;

export interface GearFrame {
  x: number;
  y: number;
}

const FRAMES: Readonly<Record<string, GearFrame>> = {
  "renders/rock_adamant_0": { x: 0, y: 0 },
  "renders/rock_adamant_1": { x: 96, y: 0 },
  "renders/rock_adamant_2": { x: 192, y: 0 },
  "renders/rock_adamant_3": { x: 288, y: 0 },
  "renders/rock_adamant_4": { x: 384, y: 0 },
  "renders/rock_basalt_0": { x: 480, y: 0 },
  "renders/rock_basalt_1": { x: 576, y: 0 },
  "renders/rock_basalt_2": { x: 672, y: 0 },
  "renders/rock_basalt_3": { x: 0, y: 96 },
  "renders/rock_basalt_4": { x: 96, y: 96 },
  "renders/rock_granite_0": { x: 192, y: 96 },
  "renders/rock_granite_1": { x: 288, y: 96 },
  "renders/rock_granite_2": { x: 384, y: 96 },
  "renders/rock_granite_3": { x: 480, y: 96 },
  "renders/rock_granite_4": { x: 576, y: 96 },
  "renders/rock_hard_0": { x: 672, y: 96 },
  "renders/rock_hard_1": { x: 0, y: 192 },
  "renders/rock_hard_2": { x: 96, y: 192 },
  "renders/rock_hard_3": { x: 192, y: 192 },
  "renders/rock_hard_4": { x: 288, y: 192 },
  "renders/rock_loose_0": { x: 384, y: 192 },
  "renders/rock_loose_1": { x: 480, y: 192 },
  "renders/rock_loose_2": { x: 576, y: 192 },
  "renders/rock_loose_3": { x: 672, y: 192 },
  "renders/rock_loose_4": { x: 0, y: 288 },
  "renders/rock_obsidian_0": { x: 96, y: 288 },
  "renders/rock_obsidian_1": { x: 192, y: 288 },
  "renders/rock_obsidian_2": { x: 288, y: 288 },
  "renders/rock_obsidian_3": { x: 384, y: 288 },
  "renders/rock_obsidian_4": { x: 480, y: 288 },
  "renders/rock_quartz_0": { x: 576, y: 288 },
  "renders/rock_quartz_1": { x: 672, y: 288 },
  "renders/rock_quartz_2": { x: 0, y: 384 },
  "renders/rock_quartz_3": { x: 96, y: 384 },
  "renders/rock_quartz_4": { x: 192, y: 384 },
  "renders/rock_shwe_0": { x: 288, y: 384 },
  "renders/rock_shwe_1": { x: 384, y: 384 },
  "renders/rock_shwe_2": { x: 480, y: 384 },
  "renders/rock_shwe_3": { x: 576, y: 384 },
  "renders/rock_shwe_4": { x: 672, y: 384 },
  "renders/rock_star_0": { x: 0, y: 480 },
  "renders/rock_star_1": { x: 96, y: 480 },
  "renders/rock_star_2": { x: 192, y: 480 },
  "renders/rock_star_3": { x: 288, y: 480 },
  "renders/rock_star_4": { x: 384, y: 480 },
  "renders/rock_void_0": { x: 480, y: 480 },
  "renders/rock_void_1": { x: 576, y: 480 },
  "renders/rock_void_2": { x: 672, y: 480 },
  "renders/rock_void_3": { x: 0, y: 576 },
  "renders/rock_void_4": { x: 96, y: 576 },
};

/**
 * Frame for a key, or null when the sheet has no art for it.
 *
 * Null rather than a placeholder frame is deliberate: something added before
 * its model is rendered should fall back to its emoji, not draw whatever
 * happens to sit at (0, 0).
 */
export function rockFrame(key: string): GearFrame | null {
  return FRAMES[key] ?? null;
}

export const ROCK_KEYS = Object.keys(FRAMES);
